import { DatePicker } from 'components/Input';
import React from 'react';
import { useSelector } from 'react-redux';
import selectors from 'state/selectors';
import styled from 'styled-components/macro';

export interface RangeDate {
  from?: Date | null;
  to?: Date | null;
}

const DateWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  input {
    border: 1px solid ${({ theme }) => theme.colorPalette.grey.grey5} !important;
  }

  input::placeholder {
    color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey10 : theme.colorPalette.grey.grey9};
    opacity: 1;
  }

  input::-ms-input-placeholder {
    color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey10 : theme.colorPalette.grey.grey9};
  }

  input:focus-within {
    border-color: ${({ theme }) => theme.colorPalette.turquoise.normal};
    box-shadow: ${({ theme }) => theme.colorPalette.turquoise.normal} 0 0 0 1px;
  }
`;

interface DateFiltersProps {
  rangeDate?: RangeDate;
  setRangeDate?: (rangeDate: RangeDate) => void;
}

const DateFilters = (props: DateFiltersProps) => {
  const { rangeDate, setRangeDate } = props;
  const dateFormat = useSelector(selectors.user.getUserPreference).dateFormat;

  return (
    <>
      <DateWrapper data-walkthrough="ct-date-picker">
        <DatePicker
          selected={rangeDate?.from}
          selectedTo={rangeDate?.to}
          onChange={(dates: any) => {
            if (setRangeDate) {
              if (Array.isArray(dates)) {
                const [from, to] = dates;
                setRangeDate({ from, to });
              } else {
                setRangeDate({ from: null, to: null });
              }
            }
          }}
          dateFormat={dateFormat}
          placeholderText={`${dateFormat} - ${dateFormat}`}
          isRange
          isClearable
          inputWidth="220px"
          showQuickRangeButtons
        />
      </DateWrapper>
    </>
  );
};

export default DateFilters;
